<template>
  <div class="md-detials md-layout-item md-size-100" style="margin-top: -30px;margin-bottom: -30px;">
    <md-button style="position: absolute;z-index: 5;top: 10px;right: 30px;z-index: 10;" @click="close" class="md-primary md-sm md-info right-button md-just-icon md-round">
      <md-icon>reply</md-icon>
    </md-button>
    <md-card>
      <md-card-content>
        <!-- 详情信息 + 修改按钮 + 类型选择 -->
        <div style="display: flex;">
          <!-- 左侧菜单 -->
          <div  class="scroll md-layout-item " :style="{'max-width':'250px', 'border-right':'1px solid rgba(180, 180, 180, 0.3)','margin-top':'20px', 'min-width':'200px'}">
            <div class="main-box">
              <template v-for="(firItem, firIndex) in menusList">
                <div v-if="firIndex > 0" :key="firIndex" class="line"></div>
                <div v-for="secItem in firItem" :key="secItem" @click="() => {active = secItem}" :class="{'selected': active == secItem }" class="menu-item-box">
                  {{secItem}}
                </div>
              </template>
            </div>
          </div>
          <div style="flex-grow: 1;">
            <!-- 1 -->
            <res-icon v-if="active == $I18n('app_icon')" :app_id="app_id"></res-icon>
            <!-- 2 -->
            <res-banner v-if="active == $I18n('home_page_02')" :app_id="app_id"></res-banner>
            <!-- 3 -->
            <res-launch v-if="active == $I18n('launch_scr')" :app_id="app_id"></res-launch>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import ResIcon from './ResIcon.vue';
import ResBanner from './ResBanner.vue';
import ResLaunch from './ResLaunch.vue';
export default {
  name: "res-mng",
  components: { 
    // ImageCropper,
    ResIcon, ResBanner, ResLaunch
  },
  props: {
    app_id : {
      type: Number,
      default: 0,
    },
  },
  data(){
    return {
      menusList : [
        [
          this.$I18n("app_icon"), 
          this.$I18n("home_page_02"), 
          this.$I18n("launch_scr"), 
        ],
        // [this.$I18n("problem_feedback")],
      ],
      active : this.$I18n("app_icon"), // 正在打开的子菜单
    }
  },
  created(){},
  watch:{},
  beforeDestroy(){},
  methods:{
    close(){ // 关闭弹窗
      this.$emit('close');
    },
  },
}
</script>
<style scoped>
  
  .sec .menu-item-box{
    height: 60px; 
    padding: 8px 12px;
    display: flex;
    margin-right: 8px;
  }
  .menu-item-box{
    font-size: 14px;
    height: 40px;
    margin: 6px 0;
    box-sizing: border-box;
    padding: 4px 12px;
    line-height: 32px;
    cursor: pointer;
    border-radius: 4px;
    transition: background .2s;
  }
  .menu-item-box.selected{
    background: #00bcd4;
    color: #ffffff;
  }
  .menu-item-box:hover{
    background: #f4f4f4;
  }
  .menu-item-box.selected:hover{
    background: #00bcd4;
  }
</style>